import { YoApi } from '@yooink/yorestapi/frontend/es/YoApi';

class i18nApi extends YoApi {
	async loadDefaults () {
		const { data } = await this.axios.get(this.getUrl('loadDefaults'));
		return data;
	}

	async exportToDefaults () {
		return this.simpleRequest('post', 'exportToDefaults', {});
	}
}

export default new i18nApi({
	endPoint: 'i18n'
});
